import { Actions } from './actions';
import { SYNC_FACE_ID_SUCCESS, SYNC_FACE_ID_ERROR, SYNC_FACE_ID_REQUEST } from './constants';

const initialState = {
  loading: false as boolean,
  error: null as Error | null,
};

export type syncFaceIdState = typeof initialState;

export const syncFaceIdReducer = (state: syncFaceIdState = initialState, action: Actions) => {
  switch (action.type) {
    case SYNC_FACE_ID_REQUEST: {
      return {
        ...state,
        error: null,
        loading: true,
      };
    }
    case SYNC_FACE_ID_SUCCESS: {
      return {
        loading: false,
        error: null,
      };
    }
    case SYNC_FACE_ID_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
